import { Combine } from "lucide-react";
import * as React from "react";

import { CustomButton } from "@/components/atoms";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { commonIconProps20 } from "@/utils/constants";
import { formatTestId } from "@/utils/formatTestId";

interface DropDownGroupByProps {
  viewList: string[];
  selectedItem: string;
  setSelectedItem: (item: string) => void;
}

const DropDownGroupBy: React.FC<DropDownGroupByProps> = ({
  viewList,
  selectedItem,
  setSelectedItem,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <CustomButton
          variant="filter"
          size="xs"
          data-testid="group-by-trigger"
          className="ml-2.5 px-[10px]!"
        >
          <Combine {...commonIconProps20} />
          <span className="text-xs font-bold">Group by</span>
        </CustomButton>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className="w-53"
        align="start"
        sideOffset={5}
        alignOffset={-130}
        data-testid="dropdown-group-by-content"
      >
        <DropdownMenuRadioGroup
          value={selectedItem}
          onValueChange={val => setSelectedItem(val)}
        >
          {viewList.map(elem => {
            const testId = `dropdown-group-radio-${formatTestId(elem)}`;
            return (
              <DropdownMenuRadioItem
                key={elem}
                value={elem}
                className="text-sm"
                data-testid={testId}
              >
                {elem}
              </DropdownMenuRadioItem>
            );
          })}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default DropDownGroupBy;
